export const servicesTranslations = {
  en: {
    // Main services page
    'services.title': 'Our Services',
    'services.subtitle': 'Comprehensive construction solutions delivered with excellence, innovation, and unwavering commitment to quality.',
    'services.hero.subtitle': 'Comprehensive construction solutions delivered with excellence, innovation, and unwavering commitment to quality. From concept to completion, we handle every aspect of your project.',
    'services.whatWeOffer': 'What We Offer',
    'services.keyBenefits': 'Key Benefits',
    'services.getQuoteFor': 'Get Quote for',
    'services.viewAll': 'View All Services',
    
    // Process section
    'services.process.title': 'Our Process',
    'services.process.subtitle': 'A proven methodology that ensures successful project delivery from initial concept to final completion.',
    'services.process.step1.title': 'Discovery & Planning',
    'services.process.step1.description': 'We begin by understanding your vision, requirements, and project goals.',
    'services.process.step2.title': 'Design & Engineering',
    'services.process.step2.description': 'Our team creates detailed plans and engineering solutions.',
    'services.process.step3.title': 'Construction',
    'services.process.step3.description': 'Expert execution with quality control at every stage.',
    'services.process.step4.title': 'Completion & Support',
    'services.process.step4.description': 'Final delivery and ongoing support for your project.',
    'services.process.step5.title': 'Post-Completion Review',
    'services.process.step5.description': 'Comprehensive project review and lessons learned documentation.',
    
    // Why choose section
    'services.why.title': 'Why Choose FMC for Your Project?',
    'services.why.subtitle': 'Why Choose FMC for Your Project?',
    'services.why.subtitle1': 'With over 25 years of experience and hundreds of successful projects, we bring unmatched expertise to every construction challenge.',
    'services.why.subtitle2': 'Our commitment to quality, safety, and client satisfaction sets us apart in the construction industry.',
    'services.why.feature1.title': 'Proven Track Record',
    'services.why.feature1.description': '500+ successful projects completed on time and within budget.',
    'services.why.feature2.title': 'Expert Team',
    'services.why.feature2.description': 'Skilled professionals with decades of combined experience.',
    'services.why.feature3.title': 'Timely Delivery',
    'services.why.feature3.description': 'We value your time and ensure projects are completed as scheduled.',
    'services.why.feature4.title': 'Innovation & Technology',
    'services.why.feature4.description': 'Cutting-edge construction methods and advanced project management tools.',
    'services.why.feature5.title': 'Safety First',
    'services.why.feature5.description': 'Comprehensive safety protocols and training for all team members.',
    'services.why.feature6.title': 'Environmental Responsibility',
    'services.why.feature6.description': 'Sustainable practices and eco-friendly construction solutions.',
    
    // Excellence section
    'services.excellence.title': 'Excellence in Every Service',
    'services.excellence.subtitle': 'Quality, innovation, and reliability',
    'services.excellence.button1': 'View Our Services',
    'services.excellence.button2': 'Get Free Quote',
    
    // CTA section
    'services.cta.title': 'Ready to Get Started?',
    'services.cta.subtitle': 'Let\'s discuss your project requirements and how FMC Construction can help bring your vision to life with our comprehensive services.',
    'services.cta.button1': 'Get Free Quote',
    'services.cta.button2': 'Call Us Now',
    
    // Detailed Commercial Services
    'services.detailed.commercial.title': 'Commercial Construction',
    'services.detailed.commercial.description': 'Comprehensive commercial construction services for offices, retail spaces, and industrial facilities.',
    'services.detailed.commercial.feature1': 'Office Buildings & Corporate Headquarters',
    'services.detailed.commercial.feature2': 'Retail Centers & Shopping Malls',
    'services.detailed.commercial.feature3': 'Industrial Facilities & Warehouses',
    'services.detailed.commercial.feature4': 'Restaurants & Hospitality',
    'services.detailed.commercial.feature5': 'Healthcare Facilities',
    'services.detailed.commercial.feature6': 'Educational Institutions',
    'services.detailed.commercial.benefit1': 'Custom design solutions',
    'services.detailed.commercial.benefit2': 'Advanced project management',
    'services.detailed.commercial.benefit3': 'Quality assurance programs',
    'services.detailed.commercial.benefit4': 'Timeline adherence',
    'services.detailed.commercial.benefit5': 'Cost optimization',
    
    // Detailed Residential Services
    'services.detailed.residential.title': 'Residential Development',
    'services.detailed.residential.description': 'Luxury homes and residential communities built with precision, care, and attention to detail.',
    'services.detailed.residential.feature1': 'Custom Luxury Homes',
    'services.detailed.residential.feature2': 'Multi-Family Developments',
    'services.detailed.residential.feature3': 'Townhouse Communities',
    'services.detailed.residential.feature4': 'Condominium Projects',
    'services.detailed.residential.feature5': 'Renovation & Remodeling',
    'services.detailed.residential.feature6': 'Smart Home Integration',
    'services.detailed.residential.benefit1': 'Premium materials selection',
    'services.detailed.residential.benefit2': 'Energy-efficient design',
    'services.detailed.residential.benefit3': 'Custom architectural features',
    'services.detailed.residential.benefit4': 'Warranty protection',
    'services.detailed.residential.benefit5': 'Post-construction support',
    
    // Detailed Infrastructure Services
    'services.detailed.infrastructure.title': 'Infrastructure Projects',
    'services.detailed.infrastructure.description': 'Large-scale infrastructure development including roads, bridges, utilities, and public works.',
    'services.detailed.infrastructure.feature1': 'Road & Highway Construction',
    'services.detailed.infrastructure.feature2': 'Bridge & Tunnel Projects',
    'services.detailed.infrastructure.feature3': 'Water & Sewer Systems',
    'services.detailed.infrastructure.feature4': 'Electrical Infrastructure',
    'services.detailed.infrastructure.feature5': 'Public Transportation',
    'services.detailed.infrastructure.feature6': 'Environmental Projects',
    'services.detailed.infrastructure.benefit1': 'Engineering excellence',
    'services.detailed.infrastructure.benefit2': 'Safety standards compliance',
    'services.detailed.infrastructure.benefit3': 'Environmental responsibility',
    'services.detailed.infrastructure.benefit4': 'Long-term durability',
    'services.detailed.infrastructure.benefit5': 'Community impact',
    
    // Detailed Project Management Services
    'services.detailed.projectManagement.title': 'Project Management',
    'services.detailed.projectManagement.description': 'Comprehensive project management services ensuring successful delivery of complex construction projects.',
    'services.detailed.projectManagement.feature1': 'Project Planning & Scheduling',
    'services.detailed.projectManagement.feature2': 'Budget Management',
    'services.detailed.projectManagement.feature3': 'Risk Assessment',
    'services.detailed.projectManagement.feature4': 'Quality Control',
    'services.detailed.projectManagement.feature5': 'Stakeholder Communication',
    'services.detailed.projectManagement.feature6': 'Progress Monitoring',
    'services.detailed.projectManagement.benefit1': 'Reduced project risks',
    'services.detailed.projectManagement.benefit2': 'Cost savings',
    'services.detailed.projectManagement.benefit3': 'Timeline optimization',
    'services.detailed.projectManagement.benefit4': 'Quality assurance',
    'services.detailed.projectManagement.benefit5': 'Client satisfaction',
    
    // Detailed Design Services
    'services.detailed.design.title': 'Design & Engineering',
    'services.detailed.design.description': 'Innovative design and engineering solutions that combine aesthetics with functionality and sustainability.',
    'services.detailed.design.feature1': 'Architectural Design',
    'services.detailed.design.feature2': 'Structural Engineering',
    'services.detailed.design.feature3': 'MEP Engineering',
    'services.detailed.design.feature4': 'Sustainable Design',
    'services.detailed.design.feature5': '3D Modeling & BIM',
    'services.detailed.design.feature6': 'Construction Documentation',
    'services.detailed.design.benefit1': 'Innovative solutions',
    'services.detailed.design.benefit2': 'Sustainable practices',
    'services.detailed.design.benefit3': 'Cost-effective design',
    'services.detailed.design.benefit4': 'Regulatory compliance',
    'services.detailed.design.benefit5': 'Future-ready infrastructure',
    
    // Detailed Renovation Services
    'services.detailed.renovation.title': 'Renovation & Remodeling',
    'services.detailed.renovation.description': 'Transform existing spaces with our expert renovation and remodeling services.',
    'services.detailed.renovation.feature1': 'Commercial Renovations',
    'services.detailed.renovation.feature2': 'Residential Remodeling',
    'services.detailed.renovation.feature3': 'Historic Preservation',
    'services.detailed.renovation.feature4': 'Interior Upgrades',
    'services.detailed.renovation.feature5': 'Exterior Improvements',
    'services.detailed.renovation.feature6': 'Accessibility Modifications',
    'services.detailed.renovation.benefit1': 'Minimal disruption',
    'services.detailed.renovation.benefit2': 'Cost-effective solutions',
    'services.detailed.renovation.benefit3': 'Enhanced functionality',
    'services.detailed.renovation.benefit4': 'Increased property value',
    'services.detailed.renovation.benefit5': 'Modern aesthetics',
    
    // Detailed Industrial Services
    'services.detailed.industrial.title': 'Industrial Construction',
    'services.detailed.industrial.description': 'Heavy industrial facilities, manufacturing plants, and specialized industrial structures.',
    'services.detailed.industrial.feature1': 'Manufacturing Facilities',
    'services.detailed.industrial.feature2': 'Processing Plants',
    'services.detailed.industrial.feature3': 'Warehouse Complexes',
    'services.detailed.industrial.feature4': 'Industrial Parks',
    'services.detailed.industrial.feature5': 'Specialized Equipment',
    'services.detailed.industrial.feature6': 'Safety Systems',
    'services.detailed.industrial.benefit1': 'Advanced engineering solutions',
    'services.detailed.industrial.benefit2': 'Safety compliance',
    'services.detailed.industrial.benefit3': 'Operational efficiency',
    'services.detailed.industrial.benefit4': 'Scalable infrastructure',
    'services.detailed.industrial.benefit5': 'Maintenance optimization',
    
    // Service page specific translations
    'services.buildingInfrastructure.title': 'Building & Infrastructure',
    'services.buildingInfrastructure.subtitle': 'Comprehensive construction services for commercial, residential, and industrial buildings with modern infrastructure development',
    'services.buildingInfrastructure.excellence.title': 'Building Excellence',
    'services.buildingInfrastructure.excellence.highlight': 'From Foundation to Finish',
    'services.buildingInfrastructure.commercial.title': 'Commercial Construction',
    'services.buildingInfrastructure.commercial.description': 'Office buildings, retail spaces, shopping centers, and commercial complexes',
    'services.buildingInfrastructure.commercial.features': ['Modern office spaces', 'Retail environments', 'Shopping centers', 'Commercial complexes'],
    'services.buildingInfrastructure.residential.title': 'Residential Construction',
    'services.buildingInfrastructure.residential.description': 'Luxury homes, apartment buildings, and residential communities',
    'services.buildingInfrastructure.residential.features': ['Luxury homes', 'Apartment buildings', 'Residential communities', 'Custom designs'],
    'services.buildingInfrastructure.industrial.title': 'Industrial Facilities',
    'services.buildingInfrastructure.industrial.description': 'Manufacturing plants, warehouses, and industrial complexes',
    'services.buildingInfrastructure.industrial.features': ['Manufacturing plants', 'Warehouses', 'Industrial complexes', 'Specialized facilities'],
    
    'services.designEngineering.title': 'Design & Engineering',
    'services.designEngineering.subtitle': 'Professional architectural design and engineering services with innovative solutions and technical expertise',
    'services.designEngineering.excellence.title': 'Innovative Design',
    'services.designEngineering.excellence.highlight': 'Meets Engineering Excellence',
    
    'services.maintenance.title': 'Maintenance Works',
    'services.maintenance.subtitle': 'Comprehensive maintenance and facility management services for optimal building performance',
    'services.maintenance.excellence.title': 'Preventive &',
    'services.maintenance.excellence.highlight': 'Corrective Maintenance',
    'services.maintenance.corrective.title': 'Corrective Maintenance',
    'services.maintenance.corrective.description': 'Emergency repairs and troubleshooting for equipment and systems',
    'services.maintenance.corrective.features': ['Emergency repairs', 'Troubleshooting', 'Parts replacement', 'System restoration'],
    'services.maintenance.why.title': 'Why Choose FMC for Maintenance?',
    
    'services.mep.title': 'MEP Works',
    'services.mep.subtitle': 'Comprehensive mechanical, electrical, and plumbing solutions',
    'services.mep.why.title': 'Why Choose FMC for MEP Works?',
    
    // Common service elements
    'services.whyChoose.title': 'Why Choose FMC',
    'services.learnMore': 'Learn More',
    'services.getQuote': 'Get Quote',
    'services.contactUs': 'Contact Us',
    'services.projectManagement': 'Project Management',
    'services.qualityAssurance': 'Quality Assurance',
    'services.safetyStandards': 'Safety Standards',
    'services.timelyDelivery': 'Timely Delivery',
    'services.expertTeam': 'Expert Team',
    'services.professionalService': 'Professional Service',
    'services.comprehensiveSolutions': 'Comprehensive Solutions',
  },
  ar: {
    // Main services page
    'services.title': 'خدماتنا',
    'services.subtitle': 'حلول بناء شاملة تقدم بالتميز والابتكار والالتزام الثابت بالجودة.',
    'services.hero.subtitle': 'حلول بناء شاملة تقدم بالتميز والابتكار والالتزام الثابت بالجودة. من الفكرة إلى الإنجاز، نتعامل مع كل جانب من مشروعك.',
    'services.whatWeOffer': 'ما نقدمه',
    'services.keyBenefits': 'الفوائد الرئيسية',
    'services.getQuoteFor': 'احصل على عرض سعر لـ',
    'services.viewAll': 'عرض جميع الخدمات',
    
    // Process section
    'services.process.title': 'عملية العمل',
    'services.process.subtitle': 'منهجية مثبتة تضمن تسليم المشروع بنجاح من المفهوم الأولي إلى الإنجاز النهائي.',
    'services.process.step1.title': 'الاكتشاف والتخطيط',
    'services.process.step1.description': 'نبدأ بفهم رؤيتك ومتطلباتك وأهداف المشروع.',
    'services.process.step2.title': 'التصميم والهندسة',
    'services.process.step2.description': 'يُنشئ فريقنا خططاً مفصلة وحلولاً هندسية.',
    'services.process.step3.title': 'البناء',
    'services.process.step3.description': 'تنفيذ خبير مع مراقبة الجودة في كل مرحلة.',
    'services.process.step4.title': 'الإنجاز والدعم',
    'services.process.step4.description': 'التسليم النهائي والدعم المستمر لمشروعك.',
    'services.process.step5.title': 'مراجعة ما بعد الإنجاز',
    'services.process.step5.description': 'مراجعة شاملة للمشروع وتوثيق الدروس المستفادة.',
    
    // Why choose section
    'services.why.title': 'لماذا تختار إف إم سي لمشروعك؟',
    'services.why.subtitle': 'لماذا تختار إف إم سي لمشروعك؟',
    'services.why.subtitle1': 'مع أكثر من ٢٥ عاماً من الخبرة ومئات المشاريع الناجحة، نقدم خبرة لا مثيل لها لكل تحدٍ في البناء.',
    'services.why.subtitle2': 'التزامنا بالجودة والسلامة ورضا العملاء يميزنا في صناعة البناء.',
    'services.why.feature1.title': 'سجل مثبت',
    'services.why.feature1.description': '٥٠٠+ مشروع ناجح مكتمل في الوقت المحدد وفي حدود الميزانية.',
    'services.why.feature2.title': 'فريق خبير',
    'services.why.feature2.description': 'محترفون مهرة مع عقود من الخبرة المجمعة.',
    'services.why.feature3.title': 'تسليم في الوقت المحدد',
    'services.why.feature3.description': 'نقدر وقتك ونتأكد من إنجاز المشاريع كما هو مجدول.',
    'services.why.feature4.title': 'الابتكار والتكنولوجيا',
    'services.why.feature4.description': 'طرق بناء متطورة وأدوات إدارة مشاريع متقدمة.',
    'services.why.feature5.title': 'السلامة أولاً',
    'services.why.feature5.description': 'بروتوكولات سلامة شاملة وتدريب لجميع أعضاء الفريق.',
    'services.why.feature6.title': 'المسؤولية البيئية',
    'services.why.feature6.description': 'ممارسات مستدامة وحلول بناء صديقة للبيئة.',
    
    // Excellence section
    'services.excellence.title': 'التميز في كل خدمة',
    'services.excellence.subtitle': 'الجودة والابتكار والموثوقية',
    'services.excellence.button1': 'عرض خدماتنا',
    'services.excellence.button2': 'احصل على عرض سعر مجاني',
    
    // CTA section
    'services.cta.title': 'مستعد للبدء؟',
    'services.cta.subtitle': 'دعنا نناقش متطلبات مشروعك وكيف يمكن لشركة إف إم سي للبناء مساعدتك في تحقيق رؤيتك مع خدماتنا الشاملة.',
    'services.cta.button1': 'احصل على عرض سعر مجاني',
    'services.cta.button2': 'اتصل بنا الآن',
    
    // Detailed Commercial Services
    'services.detailed.commercial.title': 'البناء التجاري',
    'services.detailed.commercial.description': 'خدمات بناء تجاري شاملة للمكاتب والمساحات التجارية والمرافق الصناعية.',
    'services.detailed.commercial.feature1': 'المباني المكتبية والمقرات المؤسسية',
    'services.detailed.commercial.feature2': 'مراكز التسوق والمولات',
    'services.detailed.commercial.feature3': 'المرافق الصناعية والمستودعات',
    'services.detailed.commercial.feature4': 'المطاعم والفندقي',
    'services.detailed.commercial.feature5': 'المرافق الصحية',
    'services.detailed.commercial.feature6': 'المؤسسات التعليمية',
    'services.detailed.commercial.benefit1': 'حلول تصميم مخصصة',
    'services.detailed.commercial.benefit2': 'إدارة مشاريع متقدمة',
    'services.detailed.commercial.benefit3': 'برامج ضمان الجودة',
    'services.detailed.commercial.benefit4': 'الالتزام بالجدول الزمني',
    'services.detailed.commercial.benefit5': 'تحسين التكلفة',
    
    // Detailed Residential Services
    'services.detailed.residential.title': 'التطوير السكني',
    'services.detailed.residential.description': 'منازل فاخرة ومجتمعات سكنية مبنية بالدقة والاهتمام والاهتمام بالتفاصيل.',
    'services.detailed.residential.feature1': 'منازل فاخرة مخصصة',
    'services.detailed.residential.feature2': 'تطويرات متعددة العائلات',
    'services.detailed.residential.feature3': 'مجتمعات البيوت المتلاصقة',
    'services.detailed.residential.feature4': 'مشاريع الشقق',
    'services.detailed.residential.feature5': 'التجديد وإعادة التصميم',
    'services.detailed.residential.feature6': 'تكامل المنزل الذكي',
    'services.detailed.residential.benefit1': 'اختيار مواد عالية الجودة',
    'services.detailed.residential.benefit2': 'تصميم موفر للطاقة',
    'services.detailed.residential.benefit3': 'ميزات معمارية مخصصة',
    'services.detailed.residential.benefit4': 'حماية الضمان',
    'services.detailed.residential.benefit5': 'دعم ما بعد البناء',
    
    // Detailed Infrastructure Services
    'services.detailed.infrastructure.title': 'مشاريع البنية التحتية',
    'services.detailed.infrastructure.description': 'تطوير البنية التحتية واسع النطاق بما في ذلك الطرق والجسور والمرافق والأشغال العامة.',
    'services.detailed.infrastructure.feature1': 'بناء الطرق والطرق السريعة',
    'services.detailed.infrastructure.feature2': 'مشاريع الجسور والأنفاق',
    'services.detailed.infrastructure.feature3': 'أنظمة المياه والصرف الصحي',
    'services.detailed.infrastructure.feature4': 'البنية التحتية الكهربائية',
    'services.detailed.infrastructure.feature5': 'النقل العام',
    'services.detailed.infrastructure.feature6': 'المشاريع البيئية',
    'services.detailed.infrastructure.benefit1': 'التميز الهندسي',
    'services.detailed.infrastructure.benefit2': 'امتثال معايير السلامة',
    'services.detailed.infrastructure.benefit3': 'المسؤولية البيئية',
    'services.detailed.infrastructure.benefit4': 'المتانة طويلة المدى',
    'services.detailed.infrastructure.benefit5': 'التأثير على المجتمع',
    
    // Detailed Project Management Services
    'services.detailed.projectManagement.title': 'إدارة المشاريع',
    'services.detailed.projectManagement.description': 'خدمات إدارة مشاريع شاملة تضمن تسليم ناجح للمشاريع المعقدة.',
    'services.detailed.projectManagement.feature1': 'تخطيط وجدولة المشروع',
    'services.detailed.projectManagement.feature2': 'إدارة الميزانية',
    'services.detailed.projectManagement.feature3': 'تقييم المخاطر',
    'services.detailed.projectManagement.feature4': 'مراقبة الجودة',
    'services.detailed.projectManagement.feature5': 'تواصل أصحاب المصلحة',
    'services.detailed.projectManagement.feature6': 'مراقبة التقدم',
    'services.detailed.projectManagement.benefit1': 'تقليل مخاطر المشروع',
    'services.detailed.projectManagement.benefit2': 'توفير التكاليف',
    'services.detailed.projectManagement.benefit3': 'تحسين الجدول الزمني',
    'services.detailed.projectManagement.benefit4': 'ضمان الجودة',
    'services.detailed.projectManagement.benefit5': 'رضا العملاء',
    
    // Detailed Design Services
    'services.detailed.design.title': 'التصميم والهندسة',
    'services.detailed.design.description': 'حلول تصميم وهندسة مبتكرة تجمع بين الجماليات والوظائف والاستدامة.',
    'services.detailed.design.feature1': 'التصميم المعماري',
    'services.detailed.design.feature2': 'الهندسة الإنشائية',
    'services.detailed.design.feature3': 'هندسة الميكانيكا والكهرباء والسباكة',
    'services.detailed.design.feature4': 'التصميم المستدام',
    'services.detailed.design.feature5': 'النمذجة ثلاثية الأبعاد ونمذجة معلومات البناء',
    'services.detailed.design.feature6': 'توثيق البناء',
    'services.detailed.design.benefit1': 'حلول مبتكرة',
    'services.detailed.design.benefit2': 'ممارسات مستدامة',
    'services.detailed.design.benefit3': 'تصميم فعال من حيث التكلفة',
    'services.detailed.design.benefit4': 'الامتثال التنظيمي',
    'services.detailed.design.benefit5': 'بنية تحتية جاهزة للمستقبل',
    
    // Detailed Renovation Services
    'services.detailed.renovation.title': 'التجديد وإعادة التصميم',
    'services.detailed.renovation.description': 'حول المساحات الموجودة مع خدمات التجديد وإعادة التصميم الخبيرة.',
    'services.detailed.renovation.feature1': 'تجديدات تجارية',
    'services.detailed.renovation.feature2': 'إعادة تصميم سكنية',
    'services.detailed.renovation.feature3': 'الحفاظ على التاريخ',
    'services.detailed.renovation.feature4': 'ترقيات داخلية',
    'services.detailed.renovation.feature5': 'تحسينات خارجية',
    'services.detailed.renovation.feature6': 'تعديلات إمكانية الوصول',
    'services.detailed.renovation.benefit1': 'حد أدنى من الاضطراب',
    'services.detailed.renovation.benefit2': 'حلول فعالة من حيث التكلفة',
    'services.detailed.renovation.benefit3': 'وظائف محسنة',
    'services.detailed.renovation.benefit4': 'زيادة قيمة العقار',
    'services.detailed.renovation.benefit5': 'جماليات حديثة',
    
    // Detailed Industrial Services
    'services.detailed.industrial.title': 'البناء الصناعي',
    'services.detailed.industrial.description': 'مرافق صناعية ثقيلة ومصانع تصنيع وهياكل صناعية متخصصة.',
    'services.detailed.industrial.feature1': 'مرافق التصنيع',
    'services.detailed.industrial.feature2': 'مصانع المعالجة',
    'services.detailed.industrial.feature3': 'مجمعات المستودعات',
    'services.detailed.industrial.feature4': 'الحدائق الصناعية',
    'services.detailed.industrial.feature5': 'معدات متخصصة',
    'services.detailed.industrial.feature6': 'أنظمة السلامة',
    'services.detailed.industrial.benefit1': 'حلول هندسية متقدمة',
    'services.detailed.industrial.benefit2': 'امتثال السلامة',
    'services.detailed.industrial.benefit3': 'كفاءة تشغيلية',
    'services.detailed.industrial.benefit4': 'بنية تحتية قابلة للتوسع',
    'services.detailed.industrial.benefit5': 'تحسين الصيانة',
    
    // Service page specific translations
    'services.buildingInfrastructure.title': 'البناء والبنية التحتية',
    'services.buildingInfrastructure.subtitle': 'خدمات بناء شاملة للمباني التجارية والسكنية والصناعية مع تطوير البنية التحتية الحديثة',
    'services.buildingInfrastructure.excellence.title': 'التميز في البناء',
    'services.buildingInfrastructure.excellence.highlight': 'من الأساس إلى التشطيب',
    'services.buildingInfrastructure.commercial.title': 'البناء التجاري',
    'services.buildingInfrastructure.commercial.description': 'مباني مكتبية ومساحات تجارية ومراكز تسوق ومجمعات تجارية',
    'services.buildingInfrastructure.commercial.features': ['مساحات مكتبية حديثة', 'بيئات تجارية', 'مراكز تسوق', 'مجمعات تجارية'],
    'services.buildingInfrastructure.residential.title': 'البناء السكني',
    'services.buildingInfrastructure.residential.description': 'منازل فاخرة ومباني سكنية ومجتمعات سكنية',
    'services.buildingInfrastructure.residential.features': ['منازل فاخرة', 'مباني سكنية', 'مجتمعات سكنية', 'تصاميم مخصصة'],
    'services.buildingInfrastructure.industrial.title': 'المرافق الصناعية',
    'services.buildingInfrastructure.industrial.description': 'مصانع تصنيع ومستودعات ومجمعات صناعية',
    'services.buildingInfrastructure.industrial.features': ['مصانع تصنيع', 'مستودعات', 'مجمعات صناعية', 'مرافق متخصصة'],
    
    'services.designEngineering.title': 'التصميم والهندسة',
    'services.designEngineering.subtitle': 'خدمات التصميم المعماري والهندسي المهنية مع الحلول المبتكرة والخبرة التقنية',
    'services.designEngineering.excellence.title': 'التصميم المبتكر',
    'services.designEngineering.excellence.highlight': 'يلتقي بالتميز الهندسي',
    
    'services.maintenance.title': 'أعمال الصيانة',
    'services.maintenance.subtitle': 'خدمات الصيانة وإدارة المرافق الشاملة لأداء المبنى الأمثل',
    'services.maintenance.excellence.title': 'الصيانة الوقائية و',
    'services.maintenance.excellence.highlight': 'الصيانة التصحيحية',
    'services.maintenance.corrective.title': 'الصيانة التصحيحية',
    'services.maintenance.corrective.description': 'إصلاحات الطوارئ واستكشاف الأخطاء وإصلاحها للمعدات والأنظمة',
    'services.maintenance.corrective.features': ['إصلاحات الطوارئ', 'استكشاف الأخطاء وإصلاحها', 'استبدال الأجزاء', 'استعادة النظام'],
    'services.maintenance.why.title': 'لماذا تختار إف إم سي للصيانة؟',
    
    'services.mep.title': 'أعمال الميكانيكا والكهرباء',
    'services.mep.subtitle': 'حلول ميكانيكية وكهربائية وسباكة شاملة',
    'services.mep.why.title': 'لماذا تختار إف إم سي لأعمال الميكانيكا والكهرباء؟',
    
    // Common service elements
    'services.whyChoose.title': 'لماذا تختار إف إم سي',
    'services.learnMore': 'اعرف المزيد',
    'services.getQuote': 'احصل على عرض سعر',
    'services.contactUs': 'اتصل بنا',
    'services.projectManagement': 'إدارة المشاريع',
    'services.qualityAssurance': 'ضمان الجودة',
    'services.safetyStandards': 'معايير السلامة',
    'services.timelyDelivery': 'التسليم في الوقت المحدد',
    'services.expertTeam': 'فريق خبير',
    'services.professionalService': 'خدمة مهنية',
    'services.comprehensiveSolutions': 'حلول شاملة',
  }
};
